module.exports = __webpack_public_path__ + "static/img/xls-file.74fc60bc.svg";